import { LoaderManagerService } from '@anecdotes/design-system/loaders';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  SkipSelf,
} from '@angular/core';
import { SettingsTabs, settingsTabQueryParam, TrustCenterFacadeService } from '@anecdotes/shared-trust-center';
import { Observable } from 'rxjs';
import { TabModel } from '@anecdotes/design-system/dropdown-menu';
import { Router } from '@angular/router';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsComponent implements OnInit, OnDestroy {
  @HostBinding('class')
  private readonly classes = 'h-full flex font-main overflow-hidden';

  readonly tabs: TabModel[] = [
    {
      tabId: SettingsTabs.Notifications,
      translationKey: this.buildTranslationKey(`settings.${SettingsTabs.Notifications}.header`),
    },
    {
      tabId: SettingsTabs.Legal,
      translationKey: this.buildTranslationKey(`settings.${SettingsTabs.Legal}.header`),
    },
    {
      tabId: SettingsTabs.Automations,
      translationKey: this.buildTranslationKey(`settings.${SettingsTabs.Automations}.header`),
    },
    {
      tabId: SettingsTabs.Branding,
      translationKey: this.buildTranslationKey(`settings.${SettingsTabs.Branding}.header`),
    },
    {
      tabId: SettingsTabs.PermissionProfiles,
      translationKey: this.buildTranslationKey(`settings.${SettingsTabs.PermissionProfiles}.header`),
    },
  ];

  readonly SettingsTabs = SettingsTabs;
  isAllLoaded$: Observable<boolean>;

  selectedTab: SettingsTabs = this.tabs[0].tabId;

  private get routerTabId(): SettingsTabs {
    const queryParams = this.router.routerState.snapshot.root.queryParams;
    return queryParams?.[settingsTabQueryParam] as SettingsTabs;
  }

  constructor(
    private cd: ChangeDetectorRef,
    @SkipSelf() private loaderManager: LoaderManagerService,
    private trustCenterFacadeService: TrustCenterFacadeService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (this.routerTabId) {
      this.tabChange(this.routerTabId);
    }

    this.isAllLoaded$ = this.trustCenterFacadeService.isSettingsTabDataLoaded();
  }

  ngOnDestroy(): void {
    this.loaderManager.hide();
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  tabChange(tab: SettingsTabs): void {
    this.selectedTab = tab;
    this.cd.detectChanges();
  }
}
